'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Resize handler
//***********************************************************************************
//***********************************************************************************

import { cn_event_handler } from './cn_event_handler';
import { cn_mouse_event } from './cn_mouse_event';
import {
    cn_add,
    cn_cart,
    cn_clone,
    cn_dot,
    cn_mul,
    cn_normal,
    cn_normalize,
    cn_polar,
    cn_sub,
    cnx_add,
    cnx_clone,
    cnx_cross,
    cnx_mul,
    cnx_normalize,
    cnx_sub
} from '../utils/cn_utilities';
import { cn_camera } from './cn_camera';
import { cn_handler_object } from './cn_handler_object';
import { cn_pastille } from './cn_pastille';

export class cn_handler_translate extends cn_event_handler {
    //*****************************************************************
    /**
     * Constructor
     * @param {cn_handler_object} obj
     * @param {cn_event_handler} parent
     */
    constructor(obj, parent) {
        super(parent);
        this.object = obj;
        this._pastille = new cn_pastille([0, 0], 'arrow_all_white.svg');
        this.creation_mode = false;
    }

    //*****************************************************************
    /**
     * Draw the handler
     * @param {cn_camera} camera
     * @returns {string}
     */
    draw(camera) {
        var html = '';

        this._pastille.position = this.object.center;
        if (!this.locked)
            html += this._pastille.draw(camera);

        return html;
    }

    //*****************************************************************
    /**
     * Clear move data
     */
    clear_move() {
        this._pastille.mouseover = false;
    }

    /**
     * Manage a passive move. To return 'true' if something of interest under the mouse.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    move(ev) {
        this.clear_move();

        if (this.creation_mode) {
            this.object.center[0] = ev.mouse_world[0];
            this.object.center[1] = ev.mouse_world[1];
            return true;
        }

        this._pastille.mouseover = !this.locked && this._pastille.contains_screen(ev.mouse_screen, ev.camera);
        return this._pastille.mouseover;
    }

    /**
     * Manage a grab. To return 'true' if grab is to be managed.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    grab(ev) {
        if (this.creation_mode) return true;
        this.move(ev);
        return this._pastille.mouseover;
    }

    /**
     * During a drag and drop, the owner of the drag and drop may change.
     * Return true to accept owning the drag and drop events.
     * @param {cn_mouse_event} mouse_event
     * @returns  {boolean}
     */
    grab_element(mouse_event) {
        this._pastille.mouseover = true;
        this.drag(mouse_event);
        return true;
    }

    /**
     * Manage a drag. Only after a grab that returned true. To return 'true' if drag had an effect.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    drag(ev) {
        if (this.creation_mode) return this.move(ev);

        if (!this._pastille.mouseover) return false;
        if (ev.camera.is_3d())
            ev.move_to_plane(this.object.center, [0, 0, 1]);
        let offset = cnx_sub(ev.mouse_world, this.object.center);
        this.object.center = cnx_add(this.object.center, offset);
        this.object.update();
        this.call("change");
        return true;
    }
}

